import { useState } from 'react'

import { Boton } from '../componentes/ui'
import { aceptarCodigo, codigoPorPreguntar, rechazarCodigo } from './cookie'

/**
 * El aviso del enlace de un socio (CLAUDE.md §30): la cookie que lo recuerda no es necesaria para
 * usar el panel, así que se pregunta antes (decidido el 09-10-2026). Sale solo si la dirección
 * trae `?ref=`, y una sola vez por código.
 */
export const AvisoDeSocio = () => {
  const [codigo, setCodigo] = useState(codigoPorPreguntar)
  if (!codigo) return null
  return (
    <div aria-label="El enlace de un socio" className="fixed inset-x-4 bottom-4 z-[90] mx-auto max-w-xl rounded-caja border border-linea bg-papel p-5 text-tinta shadow-xl" role="region">
      <p className="font-semibold">Has llegado por el enlace de un socio de Wixy</p>
      <p className="mt-1 text-sm leading-relaxed text-tinta-2">
        ¿Guardamos su código en una cookie durante 180 días? Sirve para que, si abres una cuenta, te llegue el descuento de tu primer pago y al socio, su comisión. No guarda quién
        eres.{' '}
        <a className="underline" href="https://wixy.app/es/legal/cookies" rel="noreferrer" target="_blank">
          Política de cookies
        </a>
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Boton
          onClick={() => {
            aceptarCodigo(codigo)
            setCodigo(null)
          }}
          tipo="primario"
        >
          Aceptar
        </Boton>
        <Boton
          onClick={() => {
            rechazarCodigo(codigo)
            setCodigo(null)
          }}
        >
          No, gracias
        </Boton>
      </div>
    </div>
  )
}
